<template>
  <v-card class="pa-6">
    <v-card-title class="text-uppercase">
      <v-row class="my-1 justify-space-between align-center">
        <div>{{ this.user === null ? 'Crear nuevo' : 'Detalle' }} usuario</div>
        <v-switch
          v-if="user !== null && can('users:update')"
          v-model="editing"
          label="Editar"
          dense
          hide-details="auto"
        ></v-switch>
      </v-row>
    </v-card-title>
    <hr class="my-3" />

    <v-card-text v-if="user !== null" class="py-2 pb-3">
      <v-row align="center" class="mx-0" style="gap: 8px;">
        <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">Identidad:</span>
        <v-chip
          v-if="identityValidatedAt"
          small
          color="success"
          text-color="white"
        >
          Validada {{ formatDate(identityValidatedAt) }}
        </v-chip>
        <v-chip v-else small color="grey lighten-1">
          Sin validar
        </v-chip>

        <v-btn
          v-if="!identityValidatedAt && can('users:validate-identity')"
          small
          color="teal"
          dark
          :loading="validatingIdentity"
          @click="validateIdentityHandler"
          class="ml-2"
        >
          <v-icon left small>mdi-shield-check</v-icon>
          Validar identidad
        </v-btn>
      </v-row>
    </v-card-text>

    <v-card-text class="my-0 py-0">
      <v-form ref="newUserForm" v-model="formValid">
        <v-container class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
            <v-row class="my-1">
              <v-col cols="6">
                <v-text-field
                  label="Nombres"
                  v-model="newUser.name"
                  :rules="nameRules"
                  :disabled="disabled()"
                  required
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Apellidos"
                  v-model="newUser.surname"
                  :rules="nameRules"
                  :disabled="disabled()"
                  required
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="my-1">
              <v-col cols="6">
                <v-text-field
                  label="Correo electronico"
                  v-model="newUser.email"
                  :rules="emailRules"
                  :disabled="disabled()"
                  required
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="d-flex align-center">
                <div class="d-flex align-center" style="gap: 8px;">
                  <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">¿Es usuario VIP?</span>
                  <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">No</span>
                  <v-switch
                    v-model="newUser.isVip"
                    :disabled="!editing"
                    dense
                    hide-details
                    class="mt-0 pt-0"
                    color="primary"
                    inset
                  ></v-switch>
                  <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">Sí</span>
                </div>
              </v-col>
            </v-row>

            <v-row class="my-1">
              <v-col cols="6">
                <v-select
                  label="País"
                  :items="countries"
                  item-text="text"
                  item-value="iso"
                  v-model="newUser.country"
                  :disabled="disabled()"
                  :loading="loadingCountries"
                  outlined
                  dense
                  hide-details="auto"
                  @change="handleCountryChange"
                ></v-select>
              </v-col>
            </v-row>

            <v-alert v-if="addressLoadError" type="error" dense text class="my-2">
              {{ addressLoadError }}
            </v-alert>

            <mexico-address-fields
              v-if="isMexicoCountry"
              v-model="address"
              :disabled="disabled() || loadingAddress"
              :required="addressRequired"
            ></mexico-address-fields>

            <argentina-address-fields
              v-else-if="isArgentinaCountry"
              v-model="address"
              :disabled="disabled() || loadingAddress"
              :required="addressRequired"
            ></argentina-address-fields>

            <template v-else>
              <v-row class="my-1">
                <v-col cols="6">
                  <v-select
                    label="Región"
                    :items="regions"
                    item-text="name"
                    item-value="name"
                    v-model="address.region.name"
                    :disabled="disabled() || loadingAddress || !regions.length"
                    :loading="!regions.length"
                    outlined
                    dense
                    hide-details="auto"
                    @change="handleRegionChange($event)"
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-select
                    label="Comuna"
                    :items="communes"
                    item-text="name"
                    item-value="name"
                    v-model="address.commune.name"
                    :disabled="disabled() || loadingAddress || !communes.length"
                    outlined
                    dense
                    hide-details="auto"
                    @change="handleCommuneChange($event)"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="my-1">
                <v-col cols="6">
                  <v-text-field
                    label="Dirección"
                    v-model="address.street"
                    :disabled="disabled() || loadingAddress"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Número"
                    v-model="address.number"
                    :disabled="disabled() || loadingAddress"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Extra"
                    v-model="address.extra"
                    :disabled="disabled() || loadingAddress"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <v-row class="my-1">
              <v-col cols="4">
                <v-menu
                  ref="menu"
                  v-model="showBirthdayMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="displayBirthday"
                      label="Fecha de nacimiento"
                      prepend-icon="mdi-calendar"
                      :disabled="disabled()"
                      outlined
                      dense
                      readonly
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedDate"
                    :active-picker.sync="activePicker"
                    :max="today"
                    min="1950-01-01"
                    @change="saveBirthday"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  :label="identifierLabel"
                  v-model.lazy="newRut"
                  :rules="rutRules"
                  :disabled="disabled()"
                  required
                  outlined
                  dense
                  hide-details="auto"
                  @keypress="onRutKeypress"
                  @input="changeRut"
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  label="Teléfono"
                  v-model="newUser.phone"
                  :disabled="disabled()"
                  outlined
                  dense
                  hide-details="auto"
                  @input="changePhone"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text color="primary" rounded @click="closeDialog">Cerrar</v-btn>
      <v-btn
        v-if="user === null ? can('users:create') : editing && can('users:update')"
        color="primary"
        rounded
        :disabled="loadingAddress || !!addressLoadError"
        @click="validate"
      >
        Guardar
      </v-btn>
    </v-card-actions>

    <v-snackbar v-model="errorSnackbar" color="error" :timeout="5000">
      {{ errorSnackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="errorSnackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import UsersService from '../services/users.service';
import AddressService from '../services/address.service';
import CountryService from '../services/countries.service';
import RutUtils from '../utils/rut.utils';
import MexicoAddressFields from './MexicoAddressFields.vue';
import ArgentinaAddressFields from './ArgentinaAddressFields.vue';
import {
  isMexico,
  isArgentina,
  addressFormKind,
  emptyAddress,
  normalizeAddress,
  isAddressEmpty,
  addressChanged,
  missingMexicanAddressFields,
  missingArgentineAddressFields,
  toAddressPayload
} from '../utils/address.utils';
import { can } from '../utils/permissions';

export default {
  name: 'UserMaintainer',
  components: {
    MexicoAddressFields,
    ArgentinaAddressFields
  },
  props: ['user'],
  data() {
    return {
      showBirthdayMenu: false,
      editing: false,
      activePicker: null,
      newRut: '',
      selectedDate: '',
      dateChanged: false,
      newUser: {
        isVip: false
      },
      // Dirección editable y la que vino del GET: solo se manda si difieren.
      address: emptyAddress(),
      initialAddress: emptyAddress(),
      // País al que pertenece `address`; cambiar a un país con otro formulario de dirección la vacía.
      addressCountry: null,
      loadingAddress: false,
      addressLoadError: '',
      regions: [],
      communes: [],
      countries: [],
      loadingCountries: false,
      newPhone: '',
      formValid: false,
      identityValidatedAt: null,
      validatingIdentity: false,
      errorSnackbar: false,
      errorSnackbarMessage: '',
      nameRules: [v => !!v || 'El nombre es requerido'],
      emailRules: [
        v => !!v || 'Un correo electronico es requerido',
        v => /.+@.+/.test(v) || 'Debe ser un correo electrónico válido'
      ]
    };
  },
  mounted() {
    this.getRegions();
    this.getCountries();
    this.newUser = {};
    this.$refs.newUserForm.resetValidation();
    this.resetAddress();
    if (this.user) {
      this.parseUser();
      this.loadUserAddress();
      this.loadIdentityStatus();
    }
  },
  watch: {
    showBirthdayMenu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    user(val) {
      this.newUser = {};
      this.selectedDate = ''
      this.$refs.newUserForm.resetValidation();
      this.resetAddress();
      if (val) {
        this.parseUser();
        this.loadUserAddress();
        this.loadIdentityStatus();
      }
    }
  },
  computed: {
    // True only when the country positively identifies Chile (the only RUT country).
    // Governs identifier formatting and label; RUT is no longer validated.
    // Reads the editable country (not the original `user` prop) so switching
    // country while editing updates the identifier field live.
    isRutCountry() {
      return RutUtils.usesRut(this.newUser.country);
    },
    isMexicoCountry() {
      return isMexico(this.newUser.country);
    },
    isArgentinaCountry() {
      return isArgentina(this.newUser.country);
    },
    // Chile y los países que hoy comparten su formulario (Perú, Puerto Rico).
    usesChileAddressForm() {
      return addressFormKind(this.newUser.country) === 'CL';
    },
    // El backend rechaza una dirección de México o de Argentina incompleta y no deja
    // vaciar los obligatorios: si hay o hubo dirección, se exige completa.
    addressRequired() {
      return !isAddressEmpty(this.address) || !isAddressEmpty(this.initialAddress);
    },
    // Chile uses RUT; non-RUT countries (e.g. Peru) use DNI.
    identifierLabel() {
      return this.isRutCountry ? 'RUT' : 'DNI';
    },
    rutRules() {
      // Chile only: the sole RUT check is a character whitelist (digits + 'K').
      // Dots/dash are auto-formatted and 'k' is uppercased on input. No check digit.
      return this.isRutCountry
        ? [v => RutUtils.validateRutChars(v) || 'El RUT solo puede contener números y K']
        : [];
    },
    today() {
        const now = new Date();
        now.setHours(23, 59, 59, 999);
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    displayBirthday() {
    if (this.selectedDate) {
      return this.selectedDate;
    }
    if (!this.newUser.birthday) return '';
    if (this.newUser.birthday.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return this.newUser.birthday;
    }
    if (this.newUser.birthday.includes('T')) {
      const date = new Date(this.newUser.birthday);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return this.newUser.birthday;
  }
  },
  methods: {
    can,
    disabled() {
      if (this.user === null) {
        return false;
      } else {
        if (this.editing) {
          return false;
        }
        return true;
      }
    },
    closeDialog() {
      this.$emit('close-dialog');
      this.editing = false;
      this.newRut = '';
      this.dateChanged = false;
    },
    // `user` arrives in one of several shapes depending on the caller: the
    // raw Postgres row (Users.vue's list, e.g. `countryIso`/`addressStreet`/
    // `regionName` as flat fields), the "legacy" shape (`country` as an ISO
    // code, nested `address: { street, region: { name, code }, ... }`), or
    // Vision360's `prepareUserForEdit`, which already resolves `country` to
    // its display name ("Chile") instead of the ISO code the <v-select>
    // matches on. The country is normalized here; the address is not read from
    // `user` at all — none of those shapes carries codes, postal code or colonia,
    // so loadUserAddress() reads it from GET /users/:id.
    resolveUserCountry(user) {
      const raw = user.country ?? user.countryIso ?? null;
      if (!raw) return null;
      if (this.countries.some(c => c.iso === raw)) return raw;
      const byName = this.countries.find(c => c.text.toLowerCase() === String(raw).toLowerCase());
      return byName ? byName.iso : raw;
    },
    // parseUser() agrega `country` a un `newUser` recién creado, sin reactividad:
    // ni la asignación directa ni $set dispararían isMexicoCountry/isRutCountry.
    // Reemplazar el objeto sí.
    setCountry(country) {
      this.newUser = { ...this.newUser, country };
    },
    resetAddress() {
      this.address = emptyAddress();
      this.initialAddress = emptyAddress();
      this.addressCountry = null;
      this.addressLoadError = '';
      this.loadingAddress = false;
      this.communes = [];
    },
    async loadUserAddress() {
      const pgId = this.user.pgId;
      this.loadingAddress = true;
      const res = await UsersService.getUserById(pgId);
      // El diálogo pudo cambiar de usuario mientras llegaba la respuesta.
      if (!this.user || this.user.pgId !== pgId) return;
      if (res.status === 'ok') {
        if (res.data.country) {
          this.setCountry(this.resolveUserCountry(res.data));
        }
        this.address = normalizeAddress(res.data.address);
        this.initialAddress = normalizeAddress(res.data.address);
        this.addressCountry = this.newUser.country;
        if (this.usesChileAddressForm && this.address.region.name) {
          this.getCommunesByRegion(this.address.region.name);
        }
      } else {
        this.addressLoadError =
          'No se pudo cargar la dirección del usuario. Cierra y vuelve a abrir el detalle para editarlo.';
      }
      this.loadingAddress = false;
    },
    // El catálogo chileno da el código si la dirección guardada solo trae el nombre.
    withChileCodes(address) {
      const region = this.regions.find(r => r.name === address.region.name);
      const commune = this.communes.find(c => c.name === address.commune.name);
      return {
        ...address,
        region: { name: address.region.name, code: address.region.code || region?.code || '' },
        commune: { name: address.commune.name, code: address.commune.code || commune?.code || '' }
      };
    },
    // Los faltantes de la dirección según el formulario del país; Chile no exige nada aquí.
    missingAddressFields() {
      if (this.isMexicoCountry) return missingMexicanAddressFields(this.address);
      if (this.isArgentinaCountry) return missingArgentineAddressFields(this.address);
      return [];
    },
    // Solo el formulario de Chile completa los códigos desde su catálogo; México y
    // Argentina ya traen los suyos del catálogo de cada país.
    addressPayload() {
      const address = this.usesChileAddressForm ? this.withChileCodes(this.address) : this.address;
      return toAddressPayload(address, this.newUser.country);
    },
    parseUser() {
      this.dateChanged = false;
      this.newUser.id = this.user.pgId;
      this.newUser.name = this.user.name;
      this.newUser.surname = this.user.surname;
      this.newUser.email = this.user.email;
      this.newUser.country = this.resolveUserCountry(this.user);
      this.newUser.birthday = this.user.birthday;
      const dateOnly = this.user.birthday ? this.user.birthday.split('T')[0] : '';
      this.selectedDate = dateOnly;
      this.newUser.phone = this.user.phone ?? null;
      this.newUser.isVip = this.user.isVip || false;
      this.changeRut(this.user.rut);
    },
    validate() {
      if (this.$refs.newUserForm.validate()) {
        if (this.addressRequired) {
          const missing = this.missingAddressFields();
          if (missing.length) {
            this.showError(`Completa la dirección: ${missing.join(', ')}`);
            return;
          }
        }
        if (this.user === null) {
          this.createUser();
        } else if (this.editing) {
          this.updateUser();
        }
      }
    },
    saveBirthday(date) {
        if (!date || !date.match(/^\d{4}-\d{2}-\d{2}$/)) {
            this.$refs.menu.save(date);
            return;
        }
        this.selectedDate = date;
        this.dateChanged = true;
        const [year, month, day] = date.split('-');
        const yearNum = parseInt(year);
        const monthNum = parseInt(month) - 1;
        const dayNum = parseInt(day);
        if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum)) {
            this.$refs.menu.save(date);
            return;
        }
        const utcDate = new Date(Date.UTC(yearNum, monthNum, dayNum, 23, 59, 59));
        if (isNaN(utcDate.getTime())) {
            this.$refs.menu.save(date);
            return;
        }
        this.newUser.birthday = utcDate.toISOString();
        this.$refs.menu.save(date);
    },
    async createUser() {
      const userData = {
        ...this.newUser,
        address: isAddressEmpty(this.address) ? undefined : this.addressPayload()
      };
      const res = await UsersService.createUser(userData);
      if (res.status === 'ok') {
        this.$refs.newUserForm.resetValidation();
        this.closeDialog();
      } else {
        this.showError(res.message);
      }
    },
    async updateUser() {
        const userData = {
            ...this.newUser,
            address: addressChanged(this.initialAddress, this.address) ? this.addressPayload() : undefined
        };
        if (userData.birthday) {
            const testDate = new Date(userData.birthday);
            if (isNaN(testDate.getTime())) {
                return;
            }
        }
        const res = await UsersService.updateUser(userData);
        if (res.status === 'ok') {
            this.$refs.newUserForm.resetValidation();
            this.closeDialog();
        } else {
            this.showError(res.message);
        }
    },
    showError(message) {
      this.errorSnackbarMessage = message || 'Ocurrió un error al guardar los cambios';
      this.errorSnackbar = true;
    },
    async getRegions() {
      const res = await AddressService.getAllRegions();
      if (res.status === 'ok') {
        this.regions = res.data.map(r => {
          return {
            code: r.codigo,
            name: r.nombre
          };
        });
      }
    },
    async getCommunesByRegion(region) {
      const res = await AddressService.getCommunesByRegion(
        typeof region === 'object' ? region.name : region
      );
      if (res.status === 'ok') {
        this.communes = res.data.map(d => {
          return {
            name: d.nombre,
            code: d.codigo
          };
        });
      }
    },
    async getCountries() {
      this.loadingCountries = true;
      try {
        const response = await CountryService.getAllCountries(true);
        if (response.status === 'ok') {
          this.countries = (response.data || []).map(c => ({
            text: c.name ?? '',
            iso: c.iso
          }));
          // parseUser() may have already run with `countries` still empty
          // (e.g. Vision360's country-by-name shape can't be matched yet) —
          // re-resolve now that the list is loaded.
          if (this.user) {
            this.setCountry(this.resolveUserCountry(this.user));
          }
        }
      } finally {
        this.loadingCountries = false;
      }
    },
    handleCountryChange(country) {
      // Re-run the identifier formatting for the new country (RUT <-> DNI).
      this.changeRut(this.newRut);
      // México, Argentina y el resto usan catálogos distintos: la dirección de uno no sirve en otro.
      if (addressFormKind(country) !== addressFormKind(this.addressCountry)) {
        this.address = emptyAddress();
        this.communes = [];
      }
      this.addressCountry = country;
    },
    onRutKeypress(e) {
      // Chile only: block any printable char that is not a digit or 'k'/'K'.
      // Dots/dash are auto-formatted, so they must not be typed. Control keys
      // (Backspace, arrows, etc.) don't fire keypress, so they're unaffected.
      if (!this.isRutCountry) return;
      if (e.key && e.key.length === 1 && !/[0-9kK]/.test(e.key)) {
        e.preventDefault();
      }
    },
    changeRut(rut) {
      if (this.isRutCountry) {
        this.newUser.rut = RutUtils.clean(rut);
        this.newRut = RutUtils.formatRut(rut);
      } else {
        // Non-RUT country: keep the identifier (DNI/RUC) as-is, no RUT formatting.
        this.newUser.rut = rut;
        this.newRut = rut;
      }
    },
    changePhone(phone) {
      this.newUser.phone = phone;
      this.newPhone = phone;
    },
    async handleRegionChange(regionName) {
        const regionSelected = this.regions.find(r => r.name === regionName);
        this.address.region = { name: regionName, code: regionSelected?.code || '' };
        this.address.commune = { name: '', code: '' };
        this.communes = [];
        if (regionSelected) {
            await this.getCommunesByRegion(regionName);
        }
    },

    async handleCommuneChange(communeName) {
        const communeSelected = this.communes.find(c => c.name === communeName);
        this.address.commune = { name: communeName, code: communeSelected?.code || '' };
    },
    async loadIdentityStatus() {
      if (!this.user) return;
      const res = await UsersService.getIdentityStatus(this.user.pgId);
      if (res.status === 'ok') {
        this.identityValidatedAt = res.data.identityValidatedAt;
      }
    },
    async validateIdentityHandler() {
      this.validatingIdentity = true;
      const res = await UsersService.validateIdentity(this.user.pgId);
      if (res.status === 'ok') {
        await this.loadIdentityStatus();
      }
      this.validatingIdentity = false;
    },
    formatDate(isoString) {
      if (!isoString) return '';
      const d = new Date(isoString);
      return d.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
  }
};
</script>
